import Vue from 'vue'
import CommonSvc from '@/common/service/CommonSvc.js'
import SignSvc from '@/common/service/SignSvc.js'
import NewsSvc from '@/common/service/NewsSvc.js'
import SpaceSvc from '@/common/service/SpaceSvc.js'
import ManagerSvc from '@/common/service/ManagerSvc.js'
import MainSvc from '@/common/service/MainSvc.js'
import AuthSvc from '@/common/service/AuthSvc.js'
import IntroSvc from '@/common/service/IntroSvc.js'
import ConstCode from './constants/ConstCode'
import Util from './utils/Util'
import _ from 'lodash'
import Toasted from 'vue-toasted'
import BannerSvc from '@/common/service/BannerSvc.js'

Vue.use(Toasted, {
  theme: 'toasted-primary',
  position: 'bottom-center',
  duration: 3000
})
let globalVue = Vue
Vue.prototype.$_ = _
/** Service 등록 **/
Vue.prototype.$CommonSvc = CommonSvc
Vue.prototype.$SignSvc = SignSvc
Vue.prototype.$NewsSvc = NewsSvc
Vue.prototype.$SpaceSvc = SpaceSvc
Vue.prototype.$ManagerSvc = ManagerSvc
Vue.prototype.$MainSvc = MainSvc
Vue.prototype.$AuthSvc = AuthSvc
Vue.prototype.$IntroSvc = IntroSvc
Vue.prototype.$BannerSvc = BannerSvc

Vue.prototype.$ConstCode = ConstCode
Vue.prototype.$Util = Util
Vue.prototype.$windowOpen = url => window.open(url, '_blank')
Vue.prototype.$scrollToTop = () => Util.scrollToTop(250)
Vue.prototype.$alert = (msg, duration) =>
  Util.toastAlert(globalVue, msg, duration)
Vue.prototype.$confirm = (msg, actions, duration) =>
  Util.toastConfirm(globalVue, msg, actions, duration)
